import { SharedService } from 'app/layout/components/shared.service';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatListModule } from '@angular/material/list';
import { FuseSearchBarModule, FuseShortcutsModule } from '@fuse/components';
import { FuseSharedModule } from '@fuse/shared.module';
import { NewToolbarComponent } from 'app/layout/components/new-toolbar/new-toolbar.component';
import { ResetPasswordComponent } from "./reset-password/reset-password.component";
import { ClickOutsideModule } from "ng-click-outside";
import { InviteAssociateComponent } from './invite-associate/invite-associate.component';
@NgModule({
    declarations: [
        NewToolbarComponent,
        ResetPasswordComponent, InviteAssociateComponent,
        //MatDialog
    ],
    imports: [
        RouterModule,
        MatButtonModule,
        MatIconModule,
        MatBadgeModule,
        MatMenuModule,
        MatToolbarModule,
        FuseSharedModule,
        FuseSearchBarModule,
        FuseShortcutsModule,
        MatDialogModule,
        MatTooltipModule,
        // MatDialog,
        //MatDialogRef,
        MatFormFieldModule,
        MatInputModule,
        MatSelectModule,
        MatSlideToggleModule,
        MatListModule,
        ClickOutsideModule
    ],
    exports: [
        NewToolbarComponent
    ],
   
    providers: [SharedService]
})
export class NewToolbarModule {
}
